(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nn-club-capture"] && !Shopify.designMode) return;
  try {
    (() => {
  const root = document.querySelector('[data-nn-club]');
  if (!root) return;
  const dialog = root.querySelector('dialog');
  const form = root.querySelector('form');
  const inline = root.querySelector('[data-nn-club-inline]');
  const read = (key, session = false) => { try { return (session ? sessionStorage : localStorage).getItem(key); } catch { return null; } };
  const write = (key, value, session = false) => { try { (session ? sessionStorage : localStorage).setItem(key, value); } catch {} };
  const pending = read('nn-club-pending', true) === '1';
  const success = root.querySelector('[data-nn-club-success]');
  const errors = root.querySelector('[data-nn-club-errors]');
  let previousFocus;
  let previousOverflow;
  let shown = false;
  const open = () => {
    if (dialog.open) return;
    previousFocus = document.activeElement;
    previousOverflow = document.documentElement.style.overflow;
    dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
    shown = true;
    write('nn-club-seen', '1', true);
    (success || root.querySelector('input[type=email]'))?.focus();
  };
  const dismiss = () => {
    write('nn-club-dismissed-until', String(Date.now() + 14 * 86400000));
    dialog.close();
  };
  root.querySelector('[data-nn-club-close]').addEventListener('click', dismiss);
  dialog.addEventListener('cancel', event => { event.preventDefault(); dismiss(); });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dismiss();
  });
  dialog.addEventListener('close', () => { document.documentElement.style.overflow = previousOverflow || ''; previousFocus?.focus(); });
  form.addEventListener('submit', () => write('nn-club-pending', '1', true));
  if (inline) {
    const main = document.querySelector('main');
    if (main) {
      const studies = main.querySelector('#styling-studies');
      if (studies) studies.before(inline);
      else main.append(inline);
      inline.hidden = false;
    }
    inline.querySelector('button').addEventListener('click', open);
  }
  if (pending && (success || errors)) {
    write('nn-club-pending', '0', true);
    if (success) write('nn-club-joined', '1');
    open();
    return;
  }
  if (root.dataset.auto !== 'true' || root.dataset.subscriber === 'true' || read('nn-club-joined') === '1' || read('nn-club-seen', true) === '1' || Number(read('nn-club-dismissed-until')) > Date.now()) return;
  let engagedSeconds = 0;
  let scrolled = false;
  const onScroll = () => { scrolled = scrolled || window.scrollY >= 240; };
  window.addEventListener('scroll', onScroll, { passive:true });
  onScroll();
  const timer = setInterval(() => {
    if (!document.hidden && document.hasFocus()) engagedSeconds += 1;
    if (shown) { clearInterval(timer); window.removeEventListener('scroll', onScroll); return; }
    const anotherDialog = Array.from(document.querySelectorAll('dialog[open], [aria-modal="true"]')).some(element => element !== dialog && element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden');
    if (engagedSeconds >= 45 && scrolled && !anotherDialog) open();
  }, 1000);
})();
  } catch(e) { console.error(e); }
})();

})();
